/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `flat_rental` - flat_rental
 * * `revenue_share` - revenue_share
 * @export
 */
export const BookingTermsDealTypeEnum = {
    FlatRental: 'flat_rental',
    RevenueShare: 'revenue_share'
} as const;
export type BookingTermsDealTypeEnum = typeof BookingTermsDealTypeEnum[keyof typeof BookingTermsDealTypeEnum];


export function instanceOfBookingTermsDealTypeEnum(value: any): boolean {
    for (const key in BookingTermsDealTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(BookingTermsDealTypeEnum, key)) {
            if (BookingTermsDealTypeEnum[key as keyof typeof BookingTermsDealTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BookingTermsDealTypeEnumFromJSON(json: any): BookingTermsDealTypeEnum {
    return BookingTermsDealTypeEnumFromJSONTyped(json, false);
}

export function BookingTermsDealTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTermsDealTypeEnum {
    return json as BookingTermsDealTypeEnum;
}

export function BookingTermsDealTypeEnumToJSON(value?: BookingTermsDealTypeEnum | null): any {
    return value as any;
}

export function BookingTermsDealTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): BookingTermsDealTypeEnum {
    return value as BookingTermsDealTypeEnum;
}
